var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.32191 14.1286C-0.106452 14.5571 -0.106386 15.2516 0.322042 15.6799C0.75047 16.1083 1.44502 16.1083 1.87337 15.6798L8.00014 9.552L14.1274 15.6793C14.5558 16.1076 15.2504 16.1076 15.6787 15.6793C16.1071 15.2509 16.1071 14.5563 15.6787 14.128L9.55135 8.00058L15.6783 1.87256C16.1065 1.44413 16.1065 0.749581 15.6781 0.32123C15.2497 -0.107131 14.5551 -0.107066 14.1268 0.321362L7.99992 6.44926L1.87262 0.321888C1.44424 -0.106495 0.74968 -0.106495 0.321296 0.321888C-0.107099 0.750283 -0.107099 1.44483 0.321296 1.87323L6.44882 8.00069L0.32191 14.1286Z",
    fill: "#C1C2C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeXIcon);
export default __webpack_public_path__ + "static/media/intake-x-icon.7d968d989baac716966419b3bff193c2.svg";
export { ForwardRef as ReactComponent };